import { Navigation } from "@/components/Navigation";
import { Footer } from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { useState } from "react";
import { X } from "lucide-react";
import FloatingADUWizard from "@/components/FloatingADUWizard";
import FloatingReserveButton from "@/components/FloatingReserveButton";
import CanonicalTag from "@/components/CanonicalTag";

const ModernFarmhouseADUDesignFremont = () => {
  const [showCalendly, setShowCalendly] = useState(false);
  const openCalendlyModal = () => setShowCalendly(true);
  const closeCalendlyModal = () => setShowCalendly(false);

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Modern Farmhouse ADU Design & Construction in Fremont",
    "description": "Create stunning Modern Farmhouse ADUs in Fremont featuring board-and-batten siding, metal roofing, and rustic contemporary charm.",
    "url": "https://www.udaadu.com/modern-farmhouse-adu-design-fremont",
    "mainEntity": {
      "@type": "Service",
      "name": "Modern Farmhouse ADU Design & Construction",
      "provider": {
        "@type": "Organization",
        "name": "UDA ADU"
      },
      "areaServed": "Fremont, CA"
    }
  };

  return (
    <div className="min-h-screen bg-background">
      <CanonicalTag url="https://www.udaadu.com/modern-farmhouse-adu-design-fremont" />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
      />
      <Navigation />

      {/* Calendly Modal */}
      {showCalendly && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
          <div className="relative w-full max-w-2xl h-[70vh] bg-white rounded-lg overflow-hidden shadow-xl">
            <button onClick={closeCalendlyModal} className="absolute top-4 right-4 z-10 p-2 bg-white rounded-full shadow-md hover:bg-gray-100 transition-colors">
              <X className="h-6 w-6 text-gray-600" />
            </button>
            <iframe src="https://calendly.com/udaadu?embed=true&hide_gdpr_banner=1" width="100%" height="100%" frameBorder="0" title="Schedule a meeting" />
          </div>
        </div>
      )}

      <main className="max-w-6xl mx-auto px-4 py-8">
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold mb-4 text-white">
            Modern Farmhouse ADU Design & Construction in Fremont
          </h1>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            Create stunning Modern Farmhouse ADUs in Fremont featuring board-and-batten siding, metal roofing, and rustic contemporary charm.
          </p>
        </div>

        <div className="text-center mb-16">
          <Button onClick={openCalendlyModal} size="lg" className="mr-4">
            Get Free Consultation
          </Button>
          <Button asChild variant="outline" size="lg" className="text-white border-white hover:bg-white hover:text-black">
            <Link to="/adu-calculator">Calculate Costs</Link>
          </Button>
        </div>

        {/* Cost Section */}
        <section className="mb-16">
          <h2 className="text-3xl font-bold mb-8 text-center text-white">Investment Range</h2>
          <div className="text-center p-8 border border-border rounded-lg">
            <p className="text-2xl font-bold mb-4 text-white">$270,000 - $420,000</p>
            <p className="text-muted-foreground">
              Modern Farmhouse ADUs offer excellent value with their popular design and high-quality materials that appeal to Fremont residents.
            </p>
          </div>
        </section>

        {/* Final CTA */}
        <section className="text-center mb-16">
          <h2 className="text-3xl font-bold mb-8 text-white">Start Your Modern Farmhouse ADU Project</h2>
          <p className="text-xl mb-8 text-muted-foreground max-w-3xl mx-auto">
            Ready to bring Modern Farmhouse charm to your Fremont property? Let's create your perfect rustic contemporary ADU.
          </p>
          <Button onClick={openCalendlyModal} size="lg" className="mr-4">
            Schedule Consultation
          </Button>
          <Button asChild variant="outline" size="lg" className="text-white border-white hover:bg-white hover:text-black">
            <Link to="/adu-calculator">Get Cost Estimate</Link>
          </Button>
        </section>
      </main>

      <FloatingADUWizard />
      <FloatingReserveButton />
      <Footer />
    </div>
  );
};

export default ModernFarmhouseADUDesignFremont;